import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { OurNode } from "@src/cloud-connect/poc/our-node";

interface UnitTypes {
  code: number;
  display_name: string;
  description: string;
}

export class MachineSaveNodeDataInPanelHandler {
  saveNodeDataInPanel(
    node: OurNode,
    name: string,
    dataAcquisitionType: string,
    pollingIntervalTime: number,
    unit: UnitTypes,
  ) {
    const machineStructureNodeset = getMachineStructureNodeset();

    node.name = name;

    const updatedAttributes = {
      ...node.attributes,
      data_acquisition_type: dataAcquisitionType,
      sample_interval_in_seconds: pollingIntervalTime,
      unit: unit,
    };
    node.attributes = updatedAttributes;

    const singleRootNode = node.returnRootNodeFromOurNode();
    machineStructureNodeset.setRootNode(singleRootNode);
    const flatMap = singleRootNode.createMapFromOurNodeTree();
    machineStructureNodeset.setFlatMap(flatMap);
  }
}
